import React, { useState } from "react";
import CustomDropdown from "./CustomDropdown";

import { Modal } from "reactstrap";
import { getBranchByIdReq } from "../../service/branchService";
import { getUserByIdReq } from "../../service/usersService";
import DeleteConfirm from "./DeleteConfirm";
import "./styles/ActionComponent.scss";

const ActionComponent = (props) => {
    const { setEdit, type, data, clientId, validation, openModal, setOpenModal, setSelectedUserEmail, setShowResetModal, setShowDeactivateModal,setUserId, onViewBudgetClick } = props;
    const [menu, setMenu] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

  const getBranchData = async () => {
    try {
      const response = await getBranchByIdReq({
        clientId: clientId,
        branchId: data._id,
      });
      const branchValues = response?.payload?.branch;

      // Update the state immutably
      validation.setValues((prevValues) => {
        const {
          address: {
            addressLine1, addressLine2, state, city, pincode,
          },
          gstin,
          pan,
        } = branchValues;
        const { id, address, createdAt, updatedAt, _id, __v, ...rest } = prevValues.primaryBranch;
        return ({
          ...prevValues,
          primaryBranch: {
            ...rest,
            name: branchValues.name,
            addressLine1,
            addressLine2,
            state,
            city,
            pincode,
            associatedWarehouse: branchValues.associatedWarehouse?._id,
            contact: branchValues.contact,
            code: branchValues.code,
            zohoAddressId: branchValues.zohoAddressId,
            gstin: gstin?._id,
            pan: pan?._id,
        },
      });
    });
      setOpenModal({ ...openModal, branch: true });
    } catch (error) {
      console.log(error);
    }
  };

  const getUserData = async () => {
    try {
      const response = await getUserByIdReq({
        id: data._id,
      });
      const userValues = response?.payload?.user;

      const associatedBranchIds = userValues.associatedBranches.map(
        (branch) => ({ _id: branch._id, name: branch.name, code: branch.code })
      );

      validation.setValues((prevValues) => ({
        ...prevValues,
        primaryUser: {
          firstName: userValues.firstName,
          lastName: userValues.lastName,
          email: userValues.email,
          password: "",
          contact: userValues.contact.toString(),
          gender: userValues.gender,
          role: userValues.role._id,
          clientId: clientId,
          associatedBranches: [...associatedBranchIds],
        },
      }));

      setOpenModal({ ...openModal, user: true });
    } catch (error) {
      console.log(error);
    }
  };

  const onEditClick = () => {
    setEdit(data._id);
    if (type === "branch") {
      getBranchData();
    } else if (type === "user") {
      getUserData();
    }
  };

  const onBudgetClick = () => {
    onViewBudgetClick(clientId, data._id);
  };

  const onDeleteClick = () => {
    setDeleteModal(true);
  };

  const onDeactivateClick = () => {
    setShowDeactivateModal(true);
    setUserId(data._id);
  }

  return (
    <>
      <Modal size="m" isOpen={deleteModal}>
        <DeleteConfirm setDeleteModal={setDeleteModal} />
      </Modal>
      <CustomDropdown
        isOpen={menu}
        direction={"bottom"}
        toggle={() => setMenu(!menu)}
        items={[
          { label: "Edit", onClick: onEditClick },
          ...(type === "user" && setSelectedUserEmail && setShowResetModal && data?.email
            ? [{
                label: 'Send Password Reset Link',
                onClick: () => {
                  setSelectedUserEmail(data.email);
                  setShowResetModal(true);
                  setMenu(false);
                }
              }]
            : []),
          ...(type === "branch" ? [{
            label: "View Budget", onClick: onBudgetClick,
          }] : []),
        // TODO: Phase 2 - Deactivate user"
        //   ...(type === "user"
        //     ? [{ label: "Deactivate user", onClick: onDeactivateClick }]
        //     : []),
          // { label: "Delete", onClick: onDeleteClick },
        ]}
      />
    </>
  );
};
export default ActionComponent;
